export enum ColumnTypes {
  STRING,
  NUMBER,
  BOOLEAN,
  DATE,
}
